/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Booking_PassInputs */

const en_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Passes`)
};

const de_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungspässe`)
};

const es_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pases de reserva`)
};

const fr_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass de réservation`)
};

const nl_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringspassen`)
};

const it_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass prenotazione`)
};

const pt_br2_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passes de reserva`)
};

const pl_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety rezerwacyjne`)
};

const hu_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalási bérletek`)
};

const ro_admin_dashboard_invoice_tags_booking_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Booking_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase Rezervare`)
};

/**
* | output |
* | --- |
* | "Booking Passes" |
*
* @param {Admin_Dashboard_Invoice_Tags_Booking_PassInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_booking_pass = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Booking_PassInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Booking_PassInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_booking_pass(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_booking_pass(inputs)
	return ro_admin_dashboard_invoice_tags_booking_pass(inputs)
});
export { admin_dashboard_invoice_tags_booking_pass as "admin.dashboard.invoice_tags.booking_pass" }